import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from './header/header.component';
import { BannerComponent } from './banner/banner.component';
import { ContactsFooterComponent } from './contacts-footer/contacts-footer.component';

@Component({
  imports: [RouterModule, HeaderComponent, BannerComponent, ContactsFooterComponent],
  selector: 'app-root',
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {}
